module.exports = __webpack_public_path__ + "img/voice-thumb8.20156da.jpg";